export default __webpack_public_path__ + "static/media/logo-primera-blanco.595135e0.png";